// extracted by mini-css-extract-plugin
module.exports = {"contactData":"contactData--5fpbl","contactDataLast":"contactDataLast--tIsTK","title":"title--LnIIb","subTitle":"subTitle--yOKgc","subContent":"subContent--Wjb6J"};